import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Input, QueryList, ViewChild, signal, ChangeDetectorRef, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { LoadJsonServiceService } from '../../Services/Common/load-json-service.service';
import { firstValueFrom } from 'rxjs';
import { Comp, Group, SectionContent } from '../../Model/model';
import { TableComponent } from '../table/table.component';
import { CardParaComponent } from '../card-para/card-para.component';
import { ParaComponent } from "../para/para.component";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventEmitterService } from '../../Services/Common/event-emitter.service';
import { DataUnavailableComponent } from '../../Pages/common/data-unavailable/data-unavailable.component';
import { FormComponent } from '../form/form.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ManageTaxAgentsComponent } from '../../Pages/manage-tax-agents/manage-tax-agents.component';
import { SearchTaxAgentsComponent } from '../search-tax-agents/search-tax-agents.component';
import { NestedListParaLinkComponent } from '../nested-list-para-link/nested-list-para-link/nested-list-para-link.component';
import { ContactInformationComponent } from '../contact-information/contact-information.component';
import { ChatbotComponent } from '../chatbot/chatbot.component';
import { OtbCommunityComponent } from '../../Pages/otb-community/otb-community.component';
import { OtbQuestionDetailComponent } from '../otb-question-detail/otb-question-detail.component';
import { ProfileComponent } from '../../Pages/profile/profile.component';
import { AppointCallComponent } from '../../Pages/appoint-call/appoint-call.component';
import { TokenService } from '../../Services/auth';
import { SecureStorageService } from '../../Services/cache/secure-storage.service';
import { ApiService } from '../../Services/api/api.service';
import { ApiConstants } from '../../Services/api/ApiConstants';
import { AccordionComponent } from '../accordion/accordion.component';

@Component({
  selector: 'app-side-menu-content-render',
  imports: [CommonModule, FormComponent, AccordionComponent, ManageTaxAgentsComponent, FormsModule, MatIconModule, ProfileComponent, TableComponent, CardParaComponent, ParaComponent, DataUnavailableComponent, SearchTaxAgentsComponent, NestedListParaLinkComponent, ContactInformationComponent, ChatbotComponent, OtbCommunityComponent, OtbQuestionDetailComponent, AppointCallComponent],
  templateUrl: './side-menu-content-render.component.html',
  styleUrl: './side-menu-content-render.component.scss'
})
export class SideMenuContentRenderComponent implements OnInit {
  @Input() section!: SectionContent | undefined;
  @Input() parentComponent?: any;
  @ViewChild(AccordionComponent) accordions!: QueryList<AccordionComponent>
  @Input() loadingData: boolean = false;
  @Input() noData: boolean = false;

  groupSorted: Group[] = [];
  heading1: any;
  content: any;
  searchValue: any;
  selectedMenu: any;
  selectedIndex = signal<number | null>(null);
  selectedId: number | null = null;


  viewingDifferentUser: string | null = null;
  viewedUserName: string | null = null;

  get shouldShowViewingBanner(): boolean {
    try {
      if (!this.viewingDifferentUser) return false;
      const tab = (this.section?.tab || '').toLowerCase();
      return tab.includes('bank') || tab.includes('profile');
    } catch (e) { return false; }
  }

  constructor(private bus: EventEmitterService, @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef, private loadJsonService: LoadJsonServiceService, private tokenService: TokenService,
    private secureStorage: SecureStorageService, private apiService: ApiService) {
    bus.on()
      .pipe(takeUntilDestroyed())
      .subscribe(ev => {
        if (ev) {
          this.selectedMenu = ev;
          this.cdr.markForCheck();
          // this.bus.reset();
          // console.log('after reset', this.selectedMenu);
        }
      })
  }

  handleJsonButton(btn: any) {
    if (!btn || !btn.action) return;
    const action: string = btn.action;
    // Handle routeToPage('path') pattern
    const m = action.match(/routeToPage\('([^']+)'\)/);
    if (m) {
      const route = m[1];
      try { this.navigateTo('/' + route); } catch (e) { console.warn('Navigation failed', e); }
      return;
    }
    // If action looks like a full url
    if (action.startsWith('http')) {
      this.openExternalLink(action);
      //Dynamic from JSON
      // const target = (btn && btn.target) ? btn.target : '_blank';
      // if (target === '_self' || target === 'self') {
      //   try { window.location.href = action; } catch (e) { console.warn('Navigation failed', e); }
      // } else {
      //   try { window.open(action, target); } catch (e) { console.warn('Open external failed', e); }
      // Respect explicit target in JSON (e.g. "_blank" or "_self").
      const target = (btn && btn.target) ? btn.target : '_blank';
      // Support autoLogin flag to POST credentials to external URL
      if (btn && btn.autoLogin) {
        // Try TokenService first
        let applicationId = '';
        let password = '';
        try {
          const userData = this.tokenService?.getUserData && this.tokenService.getUserData();
          if (userData) {
            applicationId = userData.applicationId || userData.applicationid || userData.userId || '';
            password = userData.password || userData.pass || userData.pwd || '';
          }
        } catch (e) {
          applicationId = '';
          password = '';
        }
        // fallback: token and common localStorage keys
        if (!applicationId) {
          try {
            const token = this.tokenService?.getAccessToken && this.tokenService.getAccessToken();
            if (token) {
              password = password || token;
            }
          } catch (e) { }
        }
        if (!applicationId) {
          try {
            const raw = localStorage.getItem('credentials') || localStorage.getItem('currentUser') || localStorage.getItem('userData');
            if (raw) {
              const parsed = JSON.parse(raw);
              applicationId = applicationId || parsed.applicationId || parsed.applicationid || parsed.userId || '';
              password = password || parsed.password || parsed.pass || parsed.pwd || '';
            }
          } catch (e) { }
        }
        // If we didn't find an applicationId, as a last resort try token payload id
        if (!applicationId) {
          try {
            const token = this.tokenService?.getAccessToken && this.tokenService.getAccessToken();
            if (token) {
              const parts = token.split('.');
              if (parts.length >= 2) {
                const payload = JSON.parse(atob(parts[1]));
                applicationId = applicationId || payload.userId || payload.user || payload.sub || '';
              }
            }
          } catch (e) { }
        }
        if (!applicationId && !password) {
          // nothing to submit — open normally
          if (target === '_self' || target === 'self') { window.location.href = action; } else { window.open(action, target); }
          return;
        }
        // Submit POST to external URL
        this.submitPostForm(action, { applicationid: applicationId, password: password }, target);
        return;
      }
      if (target === '_self' || target === 'self') {
        try { window.location.href = action; } catch (e) { console.warn('Navigation failed', e); }
      } else {
        try { window.open(action, target); } catch (e) { console.warn('Open external failed', e); }
      }
      return;
      return;
    }
    // Fallback: treat action as route path
    try { this.navigateTo(action); } catch (e) { console.warn('Fallback navigation failed', e); }
  }

  userProfileData: any = null;

  ngOnInit() {
    try {
      const jsonPath = 'assets/JSONData/user-profile/userProfile.json';
      firstValueFrom(this.loadJsonService.load(jsonPath)).then((data: any) => {
        if (data) {
          this.userProfileData = data;
          this.cdr.markForCheck();
          // initialize viewingDifferentUser if present
          try {
            let val = this.secureStorage.get<any>('viewingDifferentUser', true);
            if (val) {
              if (typeof val === 'number') val = String(val);
              const s = (typeof val === 'string') ? val.trim() : '';
              if (s && s.toLowerCase() !== 'true') {
                this.viewingDifferentUser = s;
              }
            }
          } catch (e) { /* ignore */ }
        } else {
          console.warn('Could not load user profile json via LoadJsonServiceService', data);
          try {
            const profile = this.tokenService?.getUserProfile?.();
            if (profile) {
              this.userProfileData = profile;
              this.cdr.markForCheck();
            }
          } catch (e) {
            // ignore
          }
        }
      }).catch((err: any) => {
        console.warn('Error fetching user profile json via LoadJsonServiceService', err);
        try {
          const profile = this.tokenService?.getUserProfile?.();
          if (profile) {
            this.userProfileData = profile;
            this.cdr.markForCheck();
          }
        } catch (e) {
          // ignore
        }
      });
    } catch (e) {
      try {
        const profile = this.tokenService?.getUserProfile?.();
        if (profile) {
          this.userProfileData = profile;
          this.cdr.markForCheck();
        }
      } catch (err) {
        // ignore
      }
    }
  }

  onSearch() {

  }
  selectedTabIndex: any
  selectTab(index: any, tab: string) {
    // console.log("Tab selection data", index, tab);
    this.selectedTabIndex = index;
  }


  ngOnChanges() {
    // console.log("the change triggered");
    // console.log("section ..", this.section);

    if (!this.section || !this.section.components) {
      // console.log('No section data available');
      this.groupSorted = [];
      return;
    }

    const group = this.toArray<Group>(this.section.components);
    // console.log('Groups found:', group);

    this.groupSorted = group.sort((a, b) => this.num(a.position) - this.num(b.position)).map(g => ({
      ...g,
      components: this.toArray<Comp>(g?.components).sort((a, b) => this.num(a.position) - this.num(b.position)).map(c => ({
        ...c,
        components: this.toArray<Comp>(c?.data).sort((a, b) => this.num(a.position) - this.num(b.position))
      }))
    }));
    // console.log("this.groupSorted", this.groupSorted);


    let idx;
    this.groupSorted[0]?.components.forEach(element => {
      if (element.type === 'accordion') {
        element.data.forEach((el, k) => {
          if (this.selectedMenu && el.header && el.header === this.selectedMenu) {
            idx = element.accId;
            return;
          } else {
            return;
          }
        })
      }
    }

    );
    // if (!idx) {
    //   // console.log('no idx');
    //   idx = 1;
    // }
    if (typeof idx === 'number') {
      this.onChildOpened(idx);
    } else {
      this.onChildOpened(null);
    }

    try {
      const tab = this.section?.tab || '';
      if (tab && (tab.toLowerCase().includes('bank') || tab.toLowerCase().includes('profile'))) {
        let val = this.secureStorage.get<any>('viewingDifferentUser', true);
        if (typeof val === 'number') val = String(val);
        let bin: string | null = null;
        if (val && typeof val === 'string') {
          const s = val.trim();
          if (s && s.toLowerCase() !== 'true') bin = s;
        }
        if (bin) {
          this.viewingDifferentUser = bin;
          // fetch profile to get display name
          try {
            const opts = { params: { bin } };
            this.apiService.get<any>(ApiConstants.API_GET_Profile, opts).subscribe({
              next: (resp) => {
                try {
                  if (resp && resp.success && resp.data && resp.data.user && resp.data.user.name) {
                    this.viewedUserName = resp.data.user.name;
                    this.cdr.markForCheck();
                  }
                } catch (e) { }
              },
              error: () => { }
            });
          } catch (e) { /* ignore */ }
        } else {
          this.viewingDifferentUser = null;
          this.viewedUserName = null;
        }
      }
    } catch (e) { /* ignore */ }
    // console.log(this.selectedMenu);
    // console.log(idx);
    // this.onChildOpened(idx!);
  }

  onChildOpened(id: number | null) {
    this.selectedId = id;

    if (typeof id !== 'number') {
      this.selectedMenu = null;
      return;
    }

    // Scroll to the top of the opened accordion
    this.scrollToAccordion(id);
  }


  private scrollToAccordion(id: number): void {
    // Only run in browser environment
    if (id === 1) { return; }
    if (!isPlatformBrowser(this.platformId)) return;

    // Use setTimeout to ensure the accordion is fully opened before scrolling
    setTimeout(() => {
      // Find the accordion element by its data attribute
      const accordionElement = document.querySelector(`app-accordion[data-accordion-id="${id}"]`);

      if (accordionElement) {
        // Calculate offset to account for fixed header
        const headerHeight = document.querySelector('#otb-header')?.clientHeight || 0;
        const breadcrumbHeight = document.querySelector('.breadcrumb-ul')?.clientHeight || 0;
        const offset = headerHeight + breadcrumbHeight + 100; // Add 20px for spacing

        // Get the element's position
        const elementRect = accordionElement.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const scrollToPosition = absoluteElementTop - offset;

        // Scroll to the calculated position with smooth behavior
        window.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth'
        });
      }
    }, 200); // Increased delay to allow expansion animation to complete
  }


  openById(id: number) {
    this.selectedId = id;
  }


  // sortByPosition<T extends { position?: number | string }>(arr: any): T[]{
  //   const a: T[] = Array.isArray(arr) ? arr : [];
  //   return[...a].sort((x,y)=> this.num(x.position) - this.num(y.position))
  // }

  sortByPosition<T extends { position?: number | string }>(arr: T[]): T[] {
    if (!Array.isArray(arr) || arr.length === 0) return []

    const paired = arr.map((item, idx) => ({ item, idx }))
    const toNum = (v: any) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY
    }

    paired.sort((a, b) => {
      const pa = toNum(a.item?.position);
      const pb = toNum(b.item?.position);

      if (pa !== pb) return pa - pb;

      return a.idx - b.idx
    })

    return paired.map(p => p.item);
  }

  private toArray<T>(v: any): T[] {
    if (!v) return [];
    if (Array.isArray(v)) return v as T[];
    if (typeof v === 'object') {
      const object1 = ('group' in v && 'components' in v) || ('type' in v && 'data' in v)
      return (object1 ? [v] : Object.values(v)) as T[];
    }
    return [];
  }


  toLines(para: any): string[] {
    if (para === null) return []
    if (Array.isArray(para)) return para.map(v => String(v))
    return [String(para)]
  }

  private num(x: any): number {
    const n = Number(x);
    return Number.isFinite(n) ? n : 0;
  }

  trackGroup = (_: number, g: Group) => `${g.group}-${g.position}`;
  trackComp = (_: number, c: Comp) => `${c.type}-${c.position}`;


  getPrefix(index: number, type: any): any {
    if (type.nestedList) {
      type = type.nestedList.listType
    }
    // console.log(type, "type");
    // console.log(index, "index");

    if (type == 1) {
      return (index + 1) + '.';
    } else if (type == 'i') {
      const num = index + 1;
      const values = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
      const numerals = ['m', 'cm', 'd', 'cd', 'c', 'xc', 'l', 'xl', 'x', 'ix', 'v', 'iv', 'i'];

      let result = '';
      let remaining = num;

      for (let i = 0; i < values.length; i++) {
        while (remaining >= values[i]) {
          result += numerals[i];
          remaining -= values[i];
        }
      }
      return result + '.';
    } else {
      return String.fromCharCode(97 + index) + '.';
    }
  }

  getAlphaPrefix(index: number, type: any): string {
    return String.fromCharCode(97 + index) + '.';
  }

  getRomanPrefix(index: number): string {
    const romans = ['i.', 'ii.', 'iii.', 'iv.', 'v.'];
    return romans[index] || (index + 1) + '.';
  }


  isObject(item: any): boolean {
    return typeof item === 'object' && item !== null;
  }

  getItemText(item: any): string {
    return this.isObject(item) ? item.text || '' : item;
  }

  getItemNestedList(item: any): any {
    return this.isObject(item) ? item.nestedList : null;
  }

  navigateTo(route: string): void {
    // console.log('Navigating to:', route);
    window.location.href = route;
  }

  openExternalLink(url: string): void {
    // console.log('Opening external link:', url);
    window.open(url, '_blank');
  }

  private submitPostForm(url: string, data: Record<string, string>, target: string) {
    const winName = (target === '_self' || target === 'self') ? '_self' : `_auto_login_${Date.now()}`;
    if (winName !== '_self') window.open('', winName);
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = winName;
    Object.keys(data).forEach(k => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = k;
      input.value = data[k] || '';
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    form.remove();
  }

  // handleButtonClick(buttonText: string): void {
  //   if (this.parentComponent && this.parentComponent.handleButtonClick) {
  //     this.parentComponent.handleButtonClick(buttonText);
  //   }
  // }

  // getButtons(d: any): string[] {
  //   return d.buttons || [];
  // }

  handleButtonClickEvent(route: string): void {
    if (route) {
      if (route.startsWith('http')) {
        window.open(route, '_blank');
      } else {
        window.location.href = route;
      }
    }
  }


  getButtonsInfo(d: any): { label: string; link: string }[] {
    return d.buttons.map((label: string, i: number) => ({
      label, link: d.paragraphLinks[i]
    }));
  }

  getResourcesList(d: any): string[][] {
    if (d.titles && d.urls && Array.isArray(d.titles) && Array.isArray(d.urls)) {
      return [d.titles, d.urls];
    }
    return [[], []];
  }

  processText(text: string): string {
    return text.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
  }

  processTextWithLinks(text: string, link: string): string {
    let processedText = text;
    if (link && link.trim() !== '') {
      // Replace "First Home Portal" first
      processedText = processedText.replace(/First Home Portal/g, `<a href="${link}" target="_blank" rel="noopener noreferrer">First Home Portal</a>`);
      // Then replace standalone "Portal" (not already part of "First Home Portal")
      processedText = processedText.replace(/\bPortal\b(?![^<]*<\/a>)/g, `<a href="${link}" target="_blank" rel="noopener noreferrer">Portal</a>`);
    }
    // Process bold text after link replacement
    processedText = processedText.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
    return processedText;
  }

}
